import { DEFAULT_DATE_FORMAT } from '@/components/constants';
import { convertMomentToDateFnsFormat, parseTimeStamp } from '@/lib/parseTimeStamp';
import { type EHRAppointment } from '@heidi/integrations/ehr/contracts';
import { type DateFormat } from '@heidi/schema/ml-scribe';
import { format } from 'date-fns';

export const TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSS";

/**
 * Formats EHR appointment_date_time using the given date format.
 * Interprets input as local time (isUtc = false).
 */
const getEhrApptTime = (
  appointment_date_time: EHRAppointment['appointment_date_time'],
  dateFormat: DateFormat = DEFAULT_DATE_FORMAT
) => {
  const formattedCreatedTime = parseTimeStamp(appointment_date_time, false);
  return format(
    formattedCreatedTime,
    `${convertMomentToDateFnsFormat(dateFormat)} h:mma`
  );
};

export { getEhrApptTime };
